import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import FormGroup from './FormGroup';
import EyeIcon from '../icons/EyeIcon';
import Button from './Button';

const propTypes = {
  classNames: PropTypes.string,
};

const VisibilityTogglePasswordField = ({ className, ...props }) => {
  const [type, setType] = useState('password');
  const classes = classNames({
    'pos-rel': true,
    [className]: !!className,
  });

  return (
    <FormGroup
      {...props}
      className={classes}
      type={type}
      note={
        <>
          <Button
            btnStyle="reset"
            onClick={() => {
              setType(type === 'password' ? 'text' : 'password');
            }}
            className="password-visibility-toggle"
          >
            <EyeIcon size={18} color="#646e71" />
          </Button>
        </>
      }
    />
  );
};

VisibilityTogglePasswordField.propTypes = propTypes;

export default VisibilityTogglePasswordField;
